import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import * as Sentry from "@sentry/angular";
import { browserTracingIntegration, replayIntegration } from "@sentry/browser";

import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

Sentry.init({
    ...environment.sentry,
    integrations: [browserTracingIntegration(), replayIntegration()]
});

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) => {
    console.error(err);
});
